import { phoneNumberSchema } from "@gigpro/ui/Form";
import { z } from "zod";
import { makeApiResource } from "./resource";

export const managerOnDutySchema = makeApiResource({
  fullname: z.string(),
  phone_number: phoneNumberSchema,
  location_id: z.number().optional(),
});
export type ManagerOnDuty = z.infer<typeof managerOnDutySchema>;
